const styles = (theme) => ({
    root: {
        minHeight: 'calc(100vh - 56px)',
        background: theme.palette.background.default,
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 700,
    },
    intro: {
        maxWidth: 760,
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
    gridContainer: {
        justifyContent: 'center',
    },
    card: {
        padding: theme.spacing(4),
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        boxShadow: 'none',
    },
    planName: {
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },
    price: {
        marginBottom: theme.spacing(2),
    },
    featureList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        marginBottom: theme.spacing(4),
    },
    feature: {
        marginBottom: theme.spacing(1),
    },
    cardActions: {
        paddingTop: 0,
    },
    actionButton: {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        },
    },
});

export default styles;
